import React, { JSX } from "react";
import Icon from "./Icon";
import { useTranslation } from "react-i18next";
import { getDocumentaleLanguagePath } from "../i18n";
import { env } from "../lib/env";

interface IError {
    title: string;
    description: JSX.Element;
    buttonText?: string;
}

export default function ErrorBlock({ title, description, buttonText }: IError) {
    const { i18n } = useTranslation();
    const documentaleLang = getDocumentaleLanguagePath(i18n.language);

    return (
        <div className="flex flex-col justify-center text-center items-center gap-[24px] max-w-[522px]">
            <div className={`w-fit flex items-center justify-center border bg-white border-gray-300 shadow-[_0px_0.667px_1.333px_0px_rgba(16,24,40,0.05)] rounded-[12px] p-[16px] gap-[6px]`}>
                <Icon width={23} height={23} icon="info" />
            </div>
            <div className="flex flex-col gap-[12px] text-[16px] text-gray-600">
                <h1 className="text-gray-900 text-[30px] font-semibold">{title}</h1>
                <div>
                    {description}
                </div>
            </div>
            {
                buttonText &&
                <a
                    href={`${env.REACT_APP_DOCUMENTALE_URL}/${documentaleLang}`}
                    target="_blank"
                    rel="noreferrer"
                    className="bg-primary-600 font-bold border border-primary-600 rounded-[8px] text-white py-[10px] px-[18px]"
                >
                    {buttonText}
                </a>
            }
        </div >
    )
}
